import { h } from './pragma.mjs';
import { settings } from '../config/settingsFactory.mjs';
import { getValidSetting } from '../utils/common.mjs';

export default (isPublic) => {
    return (

    <footer>
    <div class="sides-auto">

        <section class="footer-upper">

            <ul class="footer-links">
                <li><a href="?userData=oportalu#uzivatelska-podpora" class="scroll-link">Uživatelská podpora</a></li>
                <li><a href="?userData=oportalu#prohlaseni-o-pristupnosti" class="scroll-link">Prohlášení o přístupnosti</a></li>
                <li><a href="?userData=oportalu#podminky-uzivani" class="scroll-link">Podmínky užívání aplikace a cookies</a></li>
            </ul>

        </section>
        <hr />
        <section class="footer-lower">
            <span>© 2025 Český úřad zeměměřický a katastrální</span>
            {isPublic ? null : (
                <span id="footer-version">{'DB : ' + getValidSetting(settings.serverTechSettings.dbEnv, '---', 'footer - dbEnv') + ' | ČÚZK login : ' + getValidSetting(settings.serverTechSettings.wsEnv, '---', 'footer - wsEnv') + ' | APV : ' + getValidSetting(settings.serverTechSettings.wsNessEnv, '---', 'footer - wsNessEnv') + ' | Verze aplikace : ' + getValidSetting(settings.serverTechSettings.version, '---', 'footer - version')}</span>
            )}
        </section>

    </div>
</footer>)
}